import {
    Component,
    Output,
    OnInit,
    HostBinding,
    OnDestroy,
    EventEmitter
} from '@angular/core';
import {
    Router
} from '@angular/router';

import { Subject } from 'rxjs';
import { tap, map, filter, combineLatest, takeUntil } from 'rxjs/operators';

import { VersionService } from '../../version.service';
import { SessionService } from '../../session.service';
import { SeasonsService } from '../../enter2.module';

const IS_OPEN_SRC = require('./assets/is-open.svg');
const IS_NW = 'isNw';
const IS_NOT_NW = 'isNotNw';
const IS_PTR = 'isPtr';
const IS_NOT_PTR = 'isNotPtr';
const IS_SEASON_ACCESS_GRANTED = 'isSeasonAccessGranted';
const IS_NOT_SEASON_ACCESS_GRANTED = 'isNotSeasonAccessGranted';

@Component({
    templateUrl: './season-world-landing.component.pug',
    styleUrls: ['./season-world-landing.component.less'],
    providers: []
})
export class SeasonWorldLandingComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @HostBinding('class.--ui') _ui = true;

    @Output() close: EventEmitter<void> = new EventEmitter();

    IS_OPEN_SRC = IS_OPEN_SRC;
    SEASON_DATE_STRING = '';

    firstSeasonItem: any = {}; 

    constructor(
        private _router: Router,

        private _versionSrv: VersionService,
        private _sessionSrv: SessionService,
        private _seasonsSrv: SeasonsService
    ) {
        this._versionSrv.data$
            .pipe(takeUntil(this._destroySbj))
            .pipe(filter((versionData) => !!versionData))
            .pipe(map(({ serverData: { features } }) => features.find(({ name }) => name === 'persistent-world')))
            .pipe(filter((feature) => !!feature))
            .pipe(combineLatest(this._seasonsSrv.accessGranted$))
            .pipe(map(([feature, isSeasonAccessGranted]) => {
                const validators = {
                    [IS_NW]: () => !!window.nw,
                    [IS_NOT_NW]: () => !window.nw,
                    [IS_PTR]: () => window.CONFIG.IS_PTR,
                    [IS_NOT_PTR]: () => !window.CONFIG.IS_PTR,
                    [IS_SEASON_ACCESS_GRANTED]: () => isSeasonAccessGranted,
                    [IS_NOT_SEASON_ACCESS_GRANTED]: () => !isSeasonAccessGranted
                };

                if(window.CONFIG.SEASON_START_TIME) {
                    this.SEASON_DATE_STRING = new Date(window.CONFIG.SEASON_START_TIME).toLocaleDateString('en-us', {month: 'long', day: 'numeric', year: 'numeric'});
                }

                const { item } = feature.menuData.find(({ item: { conditions } }) => {
                    if (!conditions) {
                        return false;
                    }

                    return !conditions.some((condition) => {
                        if (!validators[condition]) {
                            return true;
                        }

                        return !validators[condition]();
                    });
                });

                this.firstSeasonItem = item;
            }))
            .subscribe();
    }

    async ngOnInit() {
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }

    onClose() {
        this.close.emit();
    }

    async reconfig(item: IMenuItem) {
        if (item.versionData) {
            this._sessionSrv.initSessionServer({
                name: 'Seasonal server',

                apiUrl: item.config.API_URL,
                websocketUrl: item.config.WEBSOCKET_URL,
                prefix: '',

                settings: {
                    official: true,
                    host: 'screeps.com/season',
                    port: ''
                },

                users: null
            }, item.versionData);
        }

        if (item.redirectUrl) {
            this._router.navigate([item.redirectUrl]);
        }
    }
}
